import React from "react";
import { AxiosDeleteSecretApi } from "../../../utils/fetchApi/index";
import { connect } from "react-redux";
import MainLayout from "../../../components/Layout/MainLayout";
import { Table, Button, message } from "antd";
import { AxiosGetSecretApi } from "../../../utils/fetchApi";
import { changeIdLogout } from "../../../redux/actions/socket.action";
import Card from "../../../components/Card";
import ModalWarning from "../../../components/CustomsAntd/ModalWarning";
class ManagerUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      isloading: false,
      pageSize: 10,

      IDNguoiDung: undefined,
      TenDangNhap: undefined,
    };

    this.columns = [
      {
        title: "Id",
        dataIndex: "IDNguoiDung",
        align: "left",
        width: "10%",
      },
      {
        title: "Tên đăng nhập",
        dataIndex: "TenDangNhap",
        align: "left",
        width: "15%",
      },
      {
        title: "Họ và Tên",
        dataIndex: "HoVaTen",
        align: "left",
        width: "20%",
      },
      {
        title: "Tên phòng ban",
        dataIndex: "TenPhongBan",
        align: "left",
        width: "35%",
      },
      {
        title: "Quyền",
        dataIndex: "Permistion",
        align: "left",
        width: "15%",
      },

      {
        title: "Hành động",
        render: (cell, row, index) => {
          return (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ display: "flex" }}>
                <Button
                  onClick={() => {
                    this.props.history.push(
                      `/ql-nguoi-dung/${row.IDNguoiDung}/chinh-sua`
                    );
                  }}
                  style={{ marginRight: "10px", padding: 0 }}
                  type="link"
                >
                  <i
                    className="fas fa-edit"
                    style={{ fontSize: "18px", color: "#1F86EB" }}
                  ></i>
                </Button>

                <Button
                  type="link"
                  onClick={() => {
                    this.showModalDelete(row.IDNguoiDung, row.TenDangNhap);
                  }}
                >
                  <i
                    className="far fa-trash-alt"
                    style={{ fontSize: "18px", color: "red" }}
                  />
                </Button>
                {/* <CustomPopconfirm
                  title="Xác nhận xóa người dùng ?"
                  okText="Có"
                  cancelText="Không"
                  onConfirm={() => {
                    this.onDeleteUser(row.IDNguoiDung, row.TenDangNhap);
                  }}
                  content={
                    <Button type="link">
                      <i
                        className="far fa-trash-alt"
                        style={{ fontSize: "18px", color: "red" }}
                      />
                    </Button>
                  }
                /> */}
              </div>
            </div>
          );
        },
        align: "center",
        width: 150,
      },
    ];
  }
  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }
  componentDidMount() {
    window.onbeforeunload = null;
  }
  componentWillMount() {
    this.getAllUser();
  }

  async getAllUser() {
    this.setStateAsync({
      isloading: true,
    });
    try {
      let response = await AxiosGetSecretApi("/api/user/all");
      this.setStateAsync({
        dataTable: response.data,
        isloading: false,
      });
    } catch (error) {
      this.setState({ isloading: false });
    }
  }

  showModalDelete(id, username) {
    this.setState({
      isVisiableModal: true,
      IDNguoiDung: id,
      TenDangNhap: username,
    });
  }

  onCancelModal = () => {
    this.setState({ isVisiableModal: false });
  };

  onDeleteUser = async () => {
    let id = this.state.IDNguoiDung;
    let username = this.state.TenDangNhap;
    this.setState({ isVisiableModal: false });
    try {
      let response = await AxiosDeleteSecretApi(`/api/user/${id}`);
      if (response.success === true) {
        message.success(`Xóa người dùng ${username} thành công!`);
        this.props.changeIdLogout(id);
        this.setState({ showProgressBar: false });
        this.getAllUser();
      } else {
        message.error("Xóa người dùng không thành công");
      }
    } catch (error) {
      message.error("Xoá người dùng không thành công");
    }
  };

  handleTableChange = async (pagination) => {
    await this.SetStateAsync({ pagination });
    this.getAllData();
  };

  render() {
    return (
      <MainLayout {...this.props} title={"Quản lý người dùng"}>
        <div className="page-with-card">
          <Card title="Quản lý người dùng">
            <div className="manager-user">
              <Button
                className="button-create"
                onClick={() => {
                  this.props.history.push("/ql-nguoi-dung/tao-moi");
                }}
                type="primary"
              >
                <i className="fas fa-plus-square icon-create"></i>
                Tạo mới người dùng
              </Button>

              <Table
                size="small"
                columns={this.columns}
                locale={{ emptyText: "Không có dữ liệu" }}
                dataSource={this.state.dataTable}
                pagination={{
                  showSizeChanger: false,
                  pageSize: this.state.pageSize,
                }}
                loading={this.state.isloading}
                rowKey={(record) => record.IDNguoiDung}
              />
            </div>
          </Card>
        </div>

        <ModalWarning
          visible={this.state.isVisiableModal}
          title={"Bạn có chắc muốn xoá ?"}
          onOk={this.onDeleteUser}
          onCancel={this.onCancelModal}
        ></ModalWarning>
      </MainLayout>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {
  changeIdLogout: changeIdLogout,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagerUser);
